import {CommissionGroupResponseItem, CommissionGroupResponseList} from '@/types/service-response'

export class CommissionGroup {
  public constructor (
    readonly id: number,
    readonly name: string,
    readonly wert: string,
    readonly position: string
  ) {}

  static createFromResponse (responseData: CommissionGroupResponseList): Array<CommissionGroup> {
    let result: Array<CommissionGroup> = []
    if (responseData) {
      result = responseData.map((item: CommissionGroupResponseItem ) => {
        return new CommissionGroup(
          item.WertID,
          item.Bezeichnung ? item.Bezeichnung : '',
          item.Wert ? item.Wert : '',
          item.Position ? item.Position : ''
        )
      })
    }
    return result
  }
}
